import { render, staticRenderFns } from "./PromoHome.vue?vue&type=template&id=64caea4b&"
import script from "./PromoHome.vue?vue&type=script&lang=js&"
export * from "./PromoHome.vue?vue&type=script&lang=js&"
import style0 from "./PromoHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports